import { createAsyncThunk } from "@reduxjs/toolkit";

import AssetsAPI, {
  Asset,
  CreateAssetParams,
  UpdateAssetParams,
  MessageResponse,
  GetAssetResponse,
} from "../../../api/assets";
import { RootState } from "../../../app/store";


export const fetchAssets = createAsyncThunk<
  GetAssetResponse,
  string,
  { state: RootState; rejectValue: string }
>(
  "assets/fetchAssets",
  async (caseId, { rejectWithValue }) => {
    try {
      const response = await AssetsAPI.getAssets({
        case_id: caseId,
      });

      return response;
    } catch {
      return rejectWithValue("Failed to fetch assets");
    }
  },
  {
    condition(caseId, { getState }) {
      const assetsState = getState().assets;

      if (assetsState.caseId === caseId && (assetsState.status === "loading" || assetsState.status === "success")) {
        return false;
      }

      return true;
    },
  },
);

export const createAsset = createAsyncThunk<
  Asset,
  CreateAssetParams,
  { rejectValue: string }
>(
  "assets/createAsset",
  async (
    params,
    { rejectWithValue },
  ) => {
    try {
      const response =
        await AssetsAPI.createAsset(
          params,
        );

      return response;
    } catch {
      return rejectWithValue("Failed to create asset");
    }
  },
);


export const updateAsset = createAsyncThunk<
  MessageResponse,
  UpdateAssetParams,
  { rejectValue: string }
>(
  "assets/updateAsset",
  async (
    params,
    { rejectWithValue },
  ) => {
    try {
      const response =
        await AssetsAPI.updateAsset(
          params,
        );

      return response;
    } catch {
      return rejectWithValue("Failed to update asset");
    }
  },
);